// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_1aDgE","listWrap":"index_listWrap_31V7Z"};